import { UrgencyEnumOptions } from "@boundless/bl-api-client/public/models/UrgencyEnumLabels"
import { UseOfFundsEnumOptions } from "@boundless/bl-api-client/public/models/UseOfFundsEnumLabels"

import { FormChipGroup } from "@/components/form-elements/FormChipGroup"
import { FormMoneyInput } from "@/components/form-elements/FormMoneyInput"
import type { FundReadyIntakeFormValues } from "@/lib/fundready/schema"

export function StepAsk() {
  return (
    <>
      <FormMoneyInput<FundReadyIntakeFormValues>
        name="askAmount"
        label="How much are you looking to raise?"
        placeholder="$250,000"
      />
      <FormChipGroup<
        FundReadyIntakeFormValues,
        FundReadyIntakeFormValues["useOfFunds"]
      >
        name="useOfFunds"
        label="Primary use of funds"
        options={UseOfFundsEnumOptions}
      />
      <FormChipGroup<
        FundReadyIntakeFormValues,
        FundReadyIntakeFormValues["urgency"]
      >
        name="urgency"
        label="When do you need it?"
        options={UrgencyEnumOptions}
      />
    </>
  )
}
